import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { SettingType } from 'helpers/setting-type-enum'
import { setSettings } from 'slices/ui'

import client from 'api'

export const useUserSettingsUpdate = () => {
    const dispatch = useDispatch()

    const setSettingData = useCallback((settingKey: string, settingName: string, value: any, id: any, settingType: number, setId: any=null) => {
        settingType !== SettingType.ModuleSetting && dispatch(setSettings({settingName, value, settingKey}))

        if (id) {
            client.put(`/api/ixweb/ixusersettings/${id}/`, {
                "SETTINGDATA_1": typeof value === 'object' ? JSON.stringify(value) : value
                })
        } else {
            client.post('/api/ixweb/ixusersettings/',
                {"SETTINGDATA_1": typeof value === 'object' ? JSON.stringify(value) : value, "SETTINGNAME": settingName, "SETTINGTYPE": settingType, "SETTINGKEY": settingKey}
            )
            .then((res: any) => {settingType === SettingType.ModuleSetting ? dispatch(setId(res.data[0].HDR_ID)) : dispatch(setSettings({settingName, id: res.data[0].HDR_ID}))})
        }
    },[dispatch])

    return setSettingData
}